import { useMemo } from "react";

import {
  EditFRDStartRegistrationTask,
  FRDStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { FrdStartRegistrationFormProps } from "@/types/form-types";

import { useFrdUiSchema } from "../../schema/frd-ui-schema";

import { getFrdStartRegistrationSchema } from "./schema/frd-start-registration-schema";

export function FrdStartRegistrationForm(props: FrdStartRegistrationFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    FRDStartRegistrationTask | EditFRDStartRegistrationTask
  >({ key: "frdStartRegistration", task });
  const uiSchema = useFrdUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(
    () => getFrdStartRegistrationSchema({ type, isEditing }),
    [type, isEditing]
  );

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editFrdStartRegistration(formData);
    } else {
      await api.createFrdStartRegistration(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
    />
  );
}
